type IconProps = React.ComponentProps<'svg'>

export function Expand06Icon(props: IconProps) {
  return (
    <svg
      width="24"
      height="24"
      {...props}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g transform="translate(2.25, 2.25)">
        <path
          d="M5.21973 13.2197C5.51262 12.9268 5.98738 12.9268 6.28027 13.2197C6.57317 13.5126 6.57317 13.9874 6.28027 14.2803L2.56055 18H5.75C6.16421 18 6.5 18.3358 6.5 18.75C6.5 19.1642 6.16421 19.5 5.75 19.5H0.75C0.551088 19.5 0.360379 19.4209 0.219727 19.2803C0.0790746 19.1396 0 18.9489 0 18.75V13.75C5.96046e-08 13.3358 0.335787 13 0.75 13C1.16421 13 1.5 13.3358 1.5 13.75V16.9395L5.21973 13.2197Z"
          fill="currentColor"
        />
        <path
          d="M18.75 13C19.1642 13 19.5 13.3358 19.5 13.75V18.75C19.5 19.1642 19.1642 19.5 18.75 19.5H13.75C13.3358 19.5 13 19.1642 13 18.75C13 18.3358 13.3358 18 13.75 18H16.9395L13.2197 14.2803C12.9268 13.9874 12.9268 13.5126 13.2197 13.2197C13.5126 12.9268 13.9874 12.9268 14.2803 13.2197L18 16.9395V13.75C18 13.3358 18.3358 13 18.75 13Z"
          fill="currentColor"
        />
        <path
          d="M5.75 0C6.16421 -5.96046e-08 6.5 0.335786 6.5 0.75C6.5 1.16421 6.16421 1.5 5.75 1.5H2.56055L6.28027 5.21973C6.57317 5.51262 6.57317 5.98738 6.28027 6.28027C5.98738 6.57317 5.51262 6.57317 5.21973 6.28027L1.5 2.56055V5.75C1.5 6.16421 1.16421 6.5 0.75 6.5C0.335787 6.5 0 6.16421 0 5.75V0.75C2.75422e-07 0.335787 0.335787 5.96046e-08 0.75 0H5.75Z"
          fill="currentColor"
        />
        <path
          d="M18.75 0C19.1642 0 19.5 0.335787 19.5 0.75V5.75C19.5 6.16421 19.1642 6.5 18.75 6.5C18.3358 6.5 18 6.16421 18 5.75V2.56055L14.2803 6.28027C13.9874 6.57317 13.5126 6.57317 13.2197 6.28027C12.9268 5.98738 12.9268 5.51262 13.2197 5.21973L16.9395 1.5H13.75C13.3358 1.5 13 1.16421 13 0.75C13 0.335787 13.3358 0 13.75 0H18.75Z"
          fill="currentColor"
        />
      </g>
    </svg>
  )
}
